// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import compress from 'graphql-query-compress/lib/graphql-query-compress.browser.js';

export function compressQuery(query: string): string {
  return compress(query);
}
